<template>
<form>
 
    <div class="edicion_block">
        <h4 class="mb10">{{$t('comparte.comparte')}}</h4>
        <span class="info_text">
            {{$t('comparte.elije')}}
        </span>


        <ul class="list_check mt20 mb10">
   
            <li>
                <span class="label_wicon">
                    <Icon icon="ph:whatsapp-logo-light" style="color: #8C8C8C;" />
                    <b>{{$t('comparte.por')}} Whatsapp</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.whatsapp'>
                    <span class="slider round"></span>
                </label>

            </li>

            <li>
                <span class="label_wicon">
                    <Icon icon="ph:envelope-simple-light" style="color: #8C8C8C;" />
                    <b>{{$t('comparte.por')}} Email</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.email'>
                    <span class="slider round"></span>
                </label>

            </li>

            <li>
                <span class="label_wicon">
                    <Icon icon="ph:wechat-logo-light" style="color: #8C8C8C;" />
                    <b>{{$t('comparte.por')}} WeChat</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.wechat'>
                    <span class="slider round"></span>
                </label>

            </li>
            <li>
                <span class="label_wicon">
                    
                    <Icon icon="ph:chat-teardrop-dots-light" style="color: #8C8C8C;" />
                    <b>{{$t('comparte.por')}} SMS</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.sms'>
                    <span class="slider round"></span>
                </label>

            </li>

           
            <li>
                <span class="label_wicon">
                    
                    <Icon icon="ph:facebook-logo-light" style="color: #8C8C8C;" />
                    <b>{{$t('comparte.por')}} Facebook</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.facebook'>
                    <span class="slider round"></span>
                </label>

            </li>

            <li>
                <span class="label_wicon">
                    <Icon icon="ph:linkedin-logo-light" style="color: #8C8C8C;" />
                    <b>{{$t('comparte.por')}} LinkedIn</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.linkedin'>
                    <span class="slider round"></span>
                </label>

            </li>
             <li>
                <span class="label_wicon">
                    <Icon icon="ph:skype-logo-light" style="color: #8C8C8C;" />
                    
                    <b>{{$t('comparte.por')}} Skype</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.skype'>
                    <span class="slider round"></span>
                </label>

            </li>
             <li>
                <span class="label_wicon">
                    <Icon icon="ph:reddit-logo-light" style="color: #8C8C8C;" />
                    
                    <b>{{$t('comparte.por')}} Reddit</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.reddit'>
                    <span class="slider round"></span>
                </label>

            </li>
            <li>
                <span class="label_wicon">
                    <Icon icon="ph:x-logo-light" style="color: #8C8C8C;" />
                    
                    <b>{{$t('comparte.por')}} Twitter</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.twitter'>
                    <span class="slider round"></span>
                </label>

            </li>
             <li>
                <span class="label_wicon">
                    <Icon icon="ph:pinterest-logo-light" style="color: #8C8C8C;" />
                    
                    <b>{{$t('comparte.por')}} Pinterest</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.pinterest'>
                    <span class="slider round"></span>
                </label>

            </li>
             <li>
                <span class="label_wicon">
                    <Icon icon="ph:line-segments-light" style="color: #8C8C8C;" />
                    
                    <b>{{$t('comparte.por')}} Line</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.line'>
                    <span class="slider round"></span>
                </label>

            </li>
             <li>
                <span class="label_wicon">
                    <Icon icon="ph:telegram-logo-light" style="color: #8C8C8C;" />
                    
                    <b>{{$t('comparte.por')}} Telegram</b>
                </span>

                <label class="switch">
                    <input type="checkbox" v-model='preview.telegram'>
                    <span class="slider round"></span>
                </label>

            </li>

           

            


        </ul>

    </div>

    <!--<hr class="separator">

    
    -->

</form>
</template>
<script>


export default {
    computed: {
        preview () { return this.$store.getters.editingLinckard.compartir},
    },
}
</script>

<style>
#edicionLeft .list_check > li .label_wicon svg {
    margin-right: 5px;
    width: px;
    font-size: 20px;
    vertical-align: middle;
    border-style: none;
    color:'#8C8C8C' !important;
}
#edicionLeft .list_check>li .label_wicon b {
   font-weight: 400;
   display: inline-block;
   padding: 5px 0px 0px 10px;
}

</style>
